import * as React from 'react';
import * as styles from './RateIndicator.css';

export interface IRateIndicatorProps {
  ariaLabel?: string;
  rate: number;
}

export const RateIndicator: React.VFC<IRateIndicatorProps> = ({ ariaLabel, rate }) => {
  return (
    <div className={styles['container']} role="img" aria-label={ariaLabel}>
      <div className={styles['rate']} style={{ width: `${rate * 100}%` }} aria-hidden="true" />
    </div>
  );
};
